import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import api from "@/api";
import Navbar from "@/components/home/Navbar";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import CommunitySection from "@/components/home/CommunitySection";
import EventsSection from "@/components/home/EventsSection";
import FoodSection from "@/components/home/FoodSection";
import VisitorGuide from "@/components/home/VisitorGuide";
import ComingSoon from "@/components/home/ComingSoon";
import SubmitSection from "@/components/home/SubmitSection";
import SuggestionBox from "@/components/home/SuggestionBox";
import Footer from "@/components/home/Footer";

export default function Home() {
  const [entered, setEntered] = useState(false);
  const [filter, setFilter] = useState("All");
  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState(() => localStorage.getItem("ad-city") || "phl");
  const lenisRef = useRef(null);

  const city = cities.find((c) => c.id === cityId) || null;

  useEffect(() => {
    api.get("/cities").then(({ data }) => setCities(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (cities.length > 0 && !cities.some((c) => c.id === cityId)) {
      setCityId(cities[0].id);
      localStorage.setItem("ad-city", cities[0].id);
    }
  }, [cities, cityId]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => lenisRef.current?.scrollTo(target, { offset: -70 });

  const switchCity = (id) => {
    setCityId(id);
    localStorage.setItem("ad-city", id);
    setFilter("All");
    lenisRef.current?.scrollTo(0);
  };

  const enterCity = (nextFilter) => {
    if (nextFilter) setFilter(nextFilter);
    if (!entered) {
      setEntered(true);
      setTimeout(() => scrollTo("#events"), 750);
    } else {
      scrollTo("#events");
    }
  };

  return (
    <div data-testid="home-page">
      <Navbar onEnter={() => enterCity()} cities={cities} cityId={cityId} onSwitchCity={switchCity} />
      <Hero entered={entered} onEnter={enterCity} city={city} />
      <Marquee />
      <EventsSection cityId={cityId} filter={filter} setFilter={setFilter} />
      <CommunitySection cityId={cityId} />
      <ComingSoon />
      <FoodSection cityId={cityId} />
      <VisitorGuide city={city} />
      <SubmitSection cities={cities} />
      <SuggestionBox />
      <Footer city={city} />
    </div>
  );
}
